import * as React from 'react';
import {Image, Pressable, StyleSheet, View, ViewStyle} from 'react-native';

import {speechBalloonImageUrl} from '../../../../../../helpers/images';

import SpeechBalloon from '../../../../../../../domain/entities/SpeechBalloon';

interface Props {
  speechBalloon: SpeechBalloon;
  selectedSpeechBalloonId: number;
  width: number;
  onSelectSpeechBalloon: (speechBalloon: SpeechBalloon) => void;
}

const SpeechBalloonGridListItem: React.FunctionComponent<Props> = props => {
  const {speechBalloon, selectedSpeechBalloonId, width, onSelectSpeechBalloon} =
    props;
  const isActive = selectedSpeechBalloonId === speechBalloon.id;
  const height = width * aspectRatio;
  return (
    <Pressable onPress={() => onSelectSpeechBalloon(speechBalloon)}>
      <View
        style={[
          styles.imageWrapper,
          isActive ? styles.imageWrapperActive : null,
          {width, height},
        ]}>
        <Image
          style={{
            width: width - IMAGE_MARGIN_HORIZONTAL,
            height: height - IMAGE_MARGIN_VERTICAL,
          }}
          resizeMode={'contain'}
          source={{
            uri: speechBalloonImageUrl(speechBalloon, 'large'),
          }}
        />
      </View>
    </Pressable>
  );
};

export default SpeechBalloonGridListItem;

const aspectRatio = 88 / 167;

const IMAGE_MARGIN_VERTICAL = 42;
const IMAGE_MARGIN_HORIZONTAL = 22;

const styles = StyleSheet.create({
  imageWrapper: {
    justifyContent: 'center',
    alignItems: 'center',
    borderColor: 'transparent',
    borderWidth: 2,
    borderRadius: 4,
  } as ViewStyle,
  imageWrapperActive: {
    borderColor: '#ff8f13',
  } as ViewStyle,
});
